import { useEffect, useState } from "react";
import classNames from "classnames";

const CiroFadingText = ({
  className,
  fadeWindow = 300,
  text,
}: {
  className?: string;
  fadeWindow?: 300 | 500;
  text: string;
}) => {
  const [displayed, setDisplayed] = useState(text);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (text !== displayed) {
      setFading(true);
      const timeout = setTimeout(() => {
        setDisplayed(text);
        setFading(false);
      }, fadeWindow); // match transition duration
      return () => clearTimeout(timeout);
    }
  }, [text, displayed, fadeWindow]);

  return (
    <span
      className={classNames(className, "transition-opacity", {
        // Doing duration changes this way so that tailwind building picks up on it
        "duration-300": fadeWindow === 300,
        "duration-500": fadeWindow === 500,
        "opacity-0": fading,
        "opacity-100": !fading,
      })}
    >
      {displayed}
    </span>
  );
};

export default CiroFadingText;
